module.exports = {"audienceSettings":{"startDate":"2018-07-30"},"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":0,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/minimizedCardBack.json
// module id = ss4W
// module chunks = 1